const pad = (n: number) => String(n).padStart(2, "0");

/** UTC date -> "YYYY-MM-DD". */
export const isoDate = (d: Date) =>
  `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;

/** Local "today" as "YYYY-MM-DD". */
export const todayIso = () => {
  const n = new Date();
  return `${n.getFullYear()}-${pad(n.getMonth() + 1)}-${pad(n.getDate())}`;
};

export const DOW = ["Mon", "Tue", "Wed", "Thu", "Fri"];
export const DOW_LONG = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
];

/** Monday (UTC midnight) of the week containing `d`. */
export function mondayOfWeek(d: Date): Date {
  const x = new Date(
    Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()),
  );
  x.setUTCDate(x.getUTCDate() - ((x.getUTCDay() + 6) % 7));
  return x;
}

/** The five weekday "YYYY-MM-DD" strings for the week starting at `monday`. */
export function weekdayDates(monday: Date): string[] {
  const out: string[] = [];
  const d = new Date(monday);
  for (let i = 0; i < 5; i++) {
    out.push(isoDate(d));
    d.setUTCDate(d.getUTCDate() + 1);
  }
  return out;
}

/**
 * Weekday grid (Mon-Fri) for a month: rows of 5, `null` for cells outside the
 * month so the 1st lands under its real weekday.
 */
export function weeksOf(year: number, month: number): (string | null)[][] {
  const first = new Date(Date.UTC(year, month - 1, 1));
  const start = new Date(first);
  start.setUTCDate(1 - ((first.getUTCDay() + 6) % 7));
  const last = new Date(Date.UTC(year, month, 0));
  const weeks: (string | null)[][] = [];
  const ws = new Date(start);
  while (ws <= last) {
    const row: (string | null)[] = [];
    const d = new Date(ws);
    for (let i = 0; i < 5; i++) {
      row.push(
        d.getUTCFullYear() === year && d.getUTCMonth() + 1 === month
          ? isoDate(d)
          : null,
      );
      d.setUTCDate(d.getUTCDate() + 1);
    }
    weeks.push(row);
    ws.setUTCDate(ws.getUTCDate() + 7);
  }
  return weeks;
}
